import React from "react";
import VerticalTabs from "../../common/VerticalTabs";
import ApiHealthCheck from "./APIHealthCheck";
import SonarQubeReport from "./SonarQubeReport";
import TrivyReport from "./TrivyReport";
import ZapReport from "./ZapReport";

const tabs = [
  { id: "api-health", label: "API Health", component: ApiHealthCheck },
  {
    id: "sonar-qube",
    label: "SonarQube Report",
    component: SonarQubeReport,
  },
  {
    id: "trivy",
    label: "Trivy Report",
    component: TrivyReport,
  },
  {
    id: "zap",
    label: "Zap Report",
    component: ZapReport,
  },
];

const Index: React.FC = () => {
  return <VerticalTabs tabs={tabs} title="App Analytics" />;
};

export default Index;
